import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseAlertCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.16667 4.5V7.16667M7.16667 9.83333H7.17333M13.8333 7.16667C13.8333 10.8486 10.8486 13.8333 7.16667 13.8333C3.48477 13.8333 0.5 10.8486 0.5 7.16667C0.5 3.48477 3.48477 0.5 7.16667 0.5C10.8486 0.5 13.8333 3.48477 13.8333 7.16667Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseAlertCircle;
